import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postSummaryControlAction } from '../../requests/postSummaryControlAction';

export const useSummaryControlAction = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: triggerSummaryControlAction, ...rest } = useMutation({
    mutationFn: ({
      controlId,
      documentId,
    }: {
      controlId: string;
      documentId: string;
    }) =>
      postSummaryControlAction(
        constructPost,
        definitionName,
        controlId,
        documentId,
      ),
  });

  return { triggerSummaryControlAction, ...rest };
};
